export function capitalizeFirstLetter(string) {
    if (typeof string !== 'string' || string.length === 0) {
        return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function getSubstringAfterUnderscore(string) {
    if (typeof string !== 'string' || string.length === 0) {
        return '';
    }
    const underscoreIndex = string.indexOf('_');
    const substring = underscoreIndex !== -1 ? string.substring(underscoreIndex + 1) : string;
    return ' ' + capitalizeFirstLetter(substring);
}

export function isStringOrStringArray(value) {
    if (typeof value === 'string') {
        return true;
    }

    if (Array.isArray(value) && value.every(item => typeof item === 'string')) {
        return true;
    }

    return false;
}
